import React, { useState } from "react";
import { Link } from 'react-router-dom';

const GEMSMappingSubMenu = () => {
    const [dropdown, setDropdown] = useState(false);
    return (
        <ul className={dropdown ? "subMenu clicked" : "subMenu"} onClick={() => setDropdown(!dropdown)}>
            <li><Link to='/gems/sites' className='submenu-item'>ILR Site</Link></li>
            <li><Link to='/gems/ILRComponentMappings' className='submenu-item'>ILR Component Mapping</Link></li>
            <li><Link to='/gems/ILRMaterialMaps' className='submenu-item'>ILR Material Mapping</Link></li>
            <li><Link to='/gems/ILRInspectionLotRequests' className='submenu-item'>Inspection Lot Request</Link></li>
        </ul>
    );
};

export default GEMSMappingSubMenu;